import { inject, Injectable } from '@angular/core';

import { MessagesMockApi } from './common/messages/api';
import { NavigationMockApi } from './common/navigation/api';
import { NotificationsMockApi } from './common/notifications/api';
import { ShortcutsMockApi } from './common/shortcuts/api';
import { UserMockApi } from './common/user/api';
import { IconsMockApi } from './ui/icons/api';

@Injectable({ providedIn: 'root' })
export class MockApiService {
  iconsMockApi = inject(IconsMockApi);
  messagesMockApi = inject(MessagesMockApi);
  navigationMockApi = inject(NavigationMockApi);
  notificationsMockApi = inject(NotificationsMockApi);
  shortcutsMockApi = inject(ShortcutsMockApi);
  userMockApi = inject(UserMockApi);
}
